// extracted by mini-css-extract-plugin
export var component = "layout-module--component--4aX+E";
export var componentWidthFull = "layout-module--component-width-full--2951V";
export var componentWidthNarrow = "layout-module--component-width-narrow--NS6um";